import {
    Directive,
    ElementRef,
    OnInit,
    Renderer2,
    inject
} from "@angular/core";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";

@Directive({ selector: "[raskEnabledForEditRole]" })
export class EnabledForEditRoleDirective implements OnInit {
    private readonly element = inject(ElementRef);
    private readonly renderer = inject(Renderer2);
    private readonly authenticationService = inject(AuthenticationService);

    ngOnInit(): void {
        this.visibility(this.authenticationService.canEdit());
    }

    private visibility(visible: boolean) {
        this.renderer.setStyle(this.element.nativeElement, "display", visible ? "block" : "none");
    }

}
